export default __webpack_public_path__ + "static/media/antics-cover-reducedsize.dab7bcb5.png";